import React from 'react';
import { useSelector } from 'react-redux';
import ContractConfirmation from './ContractConfirmation';
import { getDraftOncoCareContractAndSaveInCache } from '../../redux/modules/oncoCareContract';

import OncoCareCalcHeader from '../../img/oncoCareCalcHeader.svg';

const OncoCareContractConfirmation = () => {
  const { loadingDraftContract, savingContractInCache } = useSelector(
    (state) => state.oncoCareContract,
  );

  return (
    <ContractConfirmation
      headerText="oncoCareContract.title"
      headerImage={OncoCareCalcHeader}
      type="oncoCare"
      loadingOrSavingInCache={loadingDraftContract || savingContractInCache}
      getDraftContractAndSaveInCache={getDraftOncoCareContractAndSaveInCache}
      imageWidth={50}
    />
  );
};

export default OncoCareContractConfirmation;
